exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fixed-header{position:-webkit-sticky;position:sticky;top:0;z-index:5;font-weight:700}table td{font-weight:inherit}.table-scroll table tr td:first-child{text-align:left;width:200px}", ""]);

// exports
